import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  ConfigProvider,
  Divider,
  Flex,
  Image,
  Popconfirm,
  Row,
  Space,
  Statistic,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import "./dashboard.css";
import { useNavigate } from "react-router-dom";
import AuthService from "../../Components/auth/AuthService";
import Message from "../../Components/common/Message";
import { useDispatch, useSelector } from "react-redux";
import {
  hideLoading,
  showLoading,
  useLoadingDispatch,
} from "../../context/loadingContext";
import {
  CheckOutlined,
  CloseOutlined,
  HistoryOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  RedoOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { getCurrentLocation } from "../../Components/Utils/geolocation";
import driveIcon from "../../assets/icons/drive.gif";
import BreakIcon from "../../assets/icons/stop.gif";
import moment from "moment";
import ActivityLog from "./ActivityLog";
import ManualTachoModal from "../../Components/Modals/ManualTachoModal";

const Auth = new AuthService();

const VehicleRoutes = () => {
  const { pinValidity } = useSelector((state) => state?.AppState?.driverData);
  const { selectedRoute } = useSelector((state) => state?.AppState?.driverData);
  const { driverRoutes } = useSelector((state) => state?.AppState?.driverData);
  const { reportSubmit } = useSelector((state) => state.AppState.driverData);

  const selectedRouteData = driverRoutes.find(
    (route) => route.id === selectedRoute,
  );
  var layoutDispatch = useLoadingDispatch();

  const securityPinExists = localStorage.getItem("securityPin");
  const delivery_date = localStorage.getItem("delivery_date");
  const readOnly = localStorage.getItem("read_only") === "true";
  const tachoType = localStorage.getItem("tachoType");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [routeOrders, setRouteOrders] = React.useState([]);
  const [accountAmount, setAccountAmount] = React.useState();
  const [cardAmount, setCardAmount] = React.useState();
  const [cashAmount, setCashAmount] = React.useState();
  const [paymentAuthorizer, setPaymentAuthorizer] = React.useState([]);
  const [reportStatus, setReportStatus] = React.useState([]);
  const [driverReturns, setDriverReturns] = React.useState([]);
  const [driveLeader, setDriveLeader] = React.useState(false);
  const [driveStatus, setDriveStatus] = React.useState(() =>
    localStorage.getItem("manualTachos")
      ? JSON.parse(localStorage.getItem("manualTachos"))
      : {
        isDriving: false,
        driveStartTime: null,
        breakStartTime: null,
      },
  );
  const [activityLog, setActivityLog] = React.useState([]);

  const [cashUpDone, setCashUpDone] = React.useState("");
  const [defectDone, setDefectDone] = React.useState(null);
  const [returnDone, setReturnDone] = React.useState(null);
  const [showManualTachoModal, setShowManualTachoModal] = useState(false);

  const checkSubmit = reportSubmit.find((rs) => rs.route_id === selectedRoute);
  if (!checkSubmit?.status) {
    navigate("/dashboard");
  }

  const getManualTachos = async (isActivityLog = false) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(
        `/driverapp/manual-tachos?route_status_id=${selectedRoute}`,
        {
          method: "GET",
        },
      );
      if (res?.ack) {
        if (isActivityLog) {
          setActivityLog(res?.manual_tachos || []);
        }
        const tachosData = res?.manual_tachos?.at(-1) || {};
        const driveStatusData = {
          isDriving: tachosData?.operation === 1 ? true : false,
          driveStartTime:
            tachosData?.operation === 1 ? tachosData?.createdAt : null,
          breakStartTime:
            tachosData?.operation === 0 ? tachosData?.createdAt : null,
        }
        setDriveStatus(driveStatusData);
        localStorage.setItem("manualTachos", JSON.stringify(driveStatusData));
      }
    } catch (error) {
      console.log(error);
      setActivityLog([]);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedRoute) return navigate("/dashboard");
      setIsLoading(true);
      showLoading(layoutDispatch);

      try {
        const res = await Auth.fetch("/driverapp/load-route-by-driver", {
          method: "POST",
          body: JSON.stringify({
            route_status_id: selectedRoute,
            delivery_date: delivery_date,
          }),
        });

        if (res.ack) {
          let route_pallets = res.route_pallets;

          let route_orders = [];
          let total_weight = 0;

          route_pallets.forEach((rp, idx) => {
            if (Number(rp.internal_id) > 0) {
              let checkOrder = route_orders.filter(
                (ro) => ro.internalId == rp.internal_id,
              );

              if (checkOrder.length > 0) {
                checkOrder[0].orderWeight += Number(rp.item_total_weight); // order_weight
                checkOrder[0].orderValue += Number(rp.gross_amount_incl_tax);

                total_weight += Number(rp.item_total_weight);

                let orderItem = {};
                orderItem.itemPalletId = rp.item_pallet_id;
                orderItem.itemRank = rp.item_rank;
                orderItem.itemCode = rp.item_id;
                orderItem.itemName = rp.item_name;
                orderItem.quantity = rp.quantity;
                orderItem.packed_quantity = Number(rp.packed_quantity) || 0;
                orderItem.item_internal_id = rp.item_internal_id;
                // orderItem.unitPrice = rp.unit_price;
                // orderItem.unitPrice =
                //   Number(rp.gross_amount_incl_tax) / Number(rp.quantity);
                orderItem.unitPrice =
                  Number(rp.quantity) === 0
                    ? 0
                    : Number(rp.gross_amount_incl_tax) / Number(rp.quantity);

                orderItem.unitPricePacked =
                  Number(rp.packed_quantity) === 0
                    ? 0
                    : Number(rp.gross_amount_incl_tax) /
                    Number(rp.packed_quantity);
                orderItem.gross_amount_incl_tax = rp.gross_amount_incl_tax;
                orderItem.item_weight = rp.item_weight;
                orderItem.item_total_weight = rp.item_total_weight;
                orderItem.deliveredQuantity = rp.delivered_quantity;
                orderItem.deliveryStatus = rp.delivery_status;

                checkOrder[0].items.push(orderItem);
              } else {
                let tempOrder = {};
                tempOrder.rank = rp.rank;
                tempOrder.internalId = rp.internal_id;
                tempOrder.customer_internal_id = rp.customer_internal_id;
                tempOrder.orderPalletId = rp.order_pallet_id;
                const delivered =
                  rp.delivered == null || rp.delivered == undefined
                    ? 0
                    : rp.delivered;
                tempOrder.delivered = delivered;
                tempOrder.deliveryDiscount = Number(rp.delivery_discount);
                tempOrder.deliveryChargeDiscountAuthBy =
                  rp.delivery_discount_auth_by;
                tempOrder.deliveryChargeDiscountStatus =
                  rp.delivery_discount_req_status;
                tempOrder.deliveryChargeDiscountNotes =
                  rp.delivery_discount_req_notes;
                tempOrder.paymentDiscountStatus = rp.payment_req_status;
                tempOrder.paymentDiscountNotes = rp.payment_req_notes;
                tempOrder.deliveryPaymentDiscountAuthBy = rp.payment_auth_by;
                tempOrder.postponedStatus = rp.postponed_status;
                tempOrder.postponedNotes = rp.postponed_notes;
                tempOrder.postponedFiles = rp.postponed_files;
                tempOrder.amountReceived = rp.amount_received;
                tempOrder.paymentMethod = rp.payment_method;
                tempOrder.notes = rp.notes;
                tempOrder.signature = rp.signature;
                tempOrder.contactNumber = rp.contact_number;
                tempOrder.customerInfo = rp.customer_info;
                tempOrder.receivedBy = rp.received_by;
                tempOrder.files = rp.files;
                tempOrder.customerName = rp.customer_project_id;
                tempOrder.customerCode = rp.customer_name;
                tempOrder.invoiceNo = rp.invoice_no;
                tempOrder.inv_internal_id = rp.inv_internal_id;
                tempOrder.security_code = rp.security_code;
                tempOrder.saleOrderNo = rp.sale_order_no;
                tempOrder.terms = rp.terms;
                tempOrder.postCode = rp.ship_zip;
                tempOrder.address = rp.ship_address1;
                tempOrder.amountReceivedAccount =
                  rp.amount_received_account || 0;
                tempOrder.amountReceivedCash = rp.amount_received_cash || 0;
                tempOrder.amountReceivedCard = rp.amount_received_card || 0;
                tempOrder.deliveryInstructions = rp.delivery_instructions;

                tempOrder.orderWeight = Number(rp.item_total_weight); // order_weight
                tempOrder.orderValue = Number(rp.gross_amount_incl_tax);

                total_weight += Number(rp.item_total_weight);

                tempOrder.items = [];

                let orderItem = {};
                orderItem.itemPalletId = rp.item_pallet_id;
                orderItem.itemRank = rp.item_rank;
                orderItem.itemCode = rp.item_id;
                orderItem.itemName = rp.item_name;
                orderItem.quantity = rp.quantity;
                orderItem.packed_quantity = rp.packed_quantity;
                orderItem.item_internal_id = rp.item_internal_id;
                // orderItem.unitPrice = rp.unit_price;
                orderItem.unitPrice =
                  Number(rp.gross_amount_incl_tax) / Number(rp.quantity);
                // orderItem.unitPricePacked =
                //   Number(rp.gross_amount_incl_tax) / Number(rp.packed_quantity);
                const qty = Number(rp.packed_quantity) || 0;
                orderItem.unitPricePacked =
                  qty > 0 ? Number(rp.gross_amount_incl_tax) / qty : 0;

                orderItem.gross_amount_incl_tax = rp.gross_amount_incl_tax;
                orderItem.item_weight = rp.item_weight;
                orderItem.item_total_weight = rp.item_total_weight;
                orderItem.deliveredQuantity = rp.delivered_quantity;
                orderItem.deliveryStatus = rp.delivery_status;

                tempOrder.items.push(orderItem);

                route_orders.push(tempOrder);
              }
            }
          });

          route_orders.sort(function (a, b) {
            return a.rank - b.rank;
          });
          route_orders.map((order) => {
            order.items.sort(function (a, b) {
              return a.itemRank - b.itemRank;
            });
          });
          console.log(route_orders);
          const totalAccountAmount = route_orders.reduce(
            (total, order) => total + order.amountReceivedAccount,
            0,
          );
          const totalCardReceived = route_orders.reduce(
            (total, order) => total + order.amountReceivedCard,
            0,
          );
          const totalCashAmount = route_orders.reduce(
            (total, order) => total + order.amountReceivedCash,
            0,
          );

          setAccountAmount(totalAccountAmount.toFixed(2));
          setCardAmount(totalCardReceived.toFixed(2));
          setCashAmount(totalCashAmount.toFixed(2));
          setRouteOrders(route_orders);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
        hideLoading(layoutDispatch);
      }
    };

    if (selectedRouteData?.start_status < 2) {
      getManualTachos();
    }

    fetchData();
    getPaymentAuthorizer();
    getReportStatus();
    getDriverReturns();
  }, []);

  const options = [];
  for (let i = 10; i < 36; i++) {
    options.push({
      label: i.toString(36) + i,
      value: i.toString(36) + i,
    });
  }

  const singleRecord = (selectedOrder) => {
    const updatedOrder = {
      ...selectedOrder,
      paymentAuthorizer: paymentAuthorizer,
    };
    navigate("/order", { state: { selectedOrder: updatedOrder } });
  };

  const updateStartStatusComplete = (routes, selectedRoute) => {
    return routes.map((route) => {
      if (route.id === selectedRoute) {
        return { ...route, start_status: 2 };
      }
      return route;
    });
  };

  const updateStartStatusOpen = (routes, selectedRoute) => {
    return routes.map((route) => {
      if (route.id === selectedRoute) {
        return { ...route, start_status: 1 };
      }
      return route;
    });
  };

  const completeOrder = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    if (!allDelivered) {
      setLoadMessage(
        `The route cannot be completed while any order(s) remain undelivered. ${str}`,
      );
      setType("error");
      return;
    }
    setIsLoading(true);
    const dataToSend = {
      route_status_id: selectedRoute,
      start_status: 2,
    };
    try {
      const res = await Auth.fetch("/driverapp/change-routes-status", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        // If driving status is active, stop it when completing the route
        if (driveStatus?.isDriving) {
          await handleDriveStatus(0);
        }

        const updatedRoutes = updateStartStatusComplete(
          driverRoutes,
          selectedRoute,
        );
        dispatch({ type: "SET_ROUTES", payload: updatedRoutes });
        // dispatch({type: 'SUBMIT_REPORT', payload: {route_id: selectedRoute, status: false}})
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        // const updatedOrder = {
        //   cashAmount: cashAmount,
        //   cardAmount: cardAmount,
        //   accountAmount: accountAmount
        // };
        // navigate("/cashup", { state: { totalAmounts : updatedOrder} });
        // navigate("/dashboard");
        // window.location.reload()
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const openOrder = async () => {
    setIsLoading(true);
    const dataToSend = {
      route_status_id: selectedRoute,
      start_status: 1,
    };
    try {
      const res = await Auth.fetch("/driverapp/change-routes-status", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        const updatedRoutes = updateStartStatusOpen(
          driverRoutes,
          selectedRoute,
        );
        dispatch({ type: "SET_ROUTES", payload: updatedRoutes });
        // dispatch({type: 'SUBMIT_REPORT', payload: {route_id: selectedRoute, status: false}})
        // window.location.reload()
        setTimeout(() => {
          window.location.reload();
        }, 1000);

        // navigate("/dashboard");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getPaymentAuthorizer = async () => {
    setIsLoading(true);

    try {
      const res = await Auth.fetch("/driverapp/get-payment-authorizers");
      if (res?.ack) {
        setPaymentAuthorizer(res?.payment_authorizers);
      } else {
        setType("error");
        setLoadMessage(res?.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getReportStatus = async () => {
    setIsLoading(true);

    try {
      const res = await Auth.fetch(
        `/driverapp/get-completed-route-status/?route_status_id=${selectedRoute}`,
      );
      if (res?.ack) {
        // setReportStatus(res?.payment_authorizers)
        setCashUpDone(res?.check_cashup);
        setDefectDone(res?.check_defect_sheet);
        setReturnDone(res?.driver_returns_updated_by);
      } else {
        setType("error");
        setLoadMessage(res?.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Number(tachoType) === 0 && !driveStatus?.isDriving) {
      const driverID = localStorage.getItem("driver_id");
      const seenIds = JSON.parse(localStorage.getItem("manualTachoModal_seen_ids") || "[]");

      if (!seenIds.includes(driverID)) {
        setShowManualTachoModal(true);
        const updatedIds = [...seenIds, driverID];
        localStorage.setItem("manualTachoModal_seen_ids", JSON.stringify(updatedIds));
      }
    }
  }, [tachoType, driveStatus, selectedRoute]);

  const getDriverReturns = async () => {
    setIsLoading(true);
    try {
      const res = await Auth.fetch(
        `/driverapp/get-driver-returns?route_status_id=${selectedRoute}`,
      );
      if (res?.ack) {
        const filterResults = res.driver_returns.filter(
          (item) => item.item_id != "Delivery Charge",
        );
        const transformedData = filterResults.reduce((acc, item) => {
          const {
            rank,
            customer_project_id,
            customer_name,
            invoice_no,
            inv_internal_id,
            item_name,
            item_id,
            quantity,
            packed_quantity,
            returned_quantity_to_stock,
            returned_quantity_to_stock_status,
            unit_price,
            delivery_status,
            delivered_quantity,
            customer_internal_id,
          } = item;

          let existingRank = acc.find((obj) => obj.rank === rank);

          if (existingRank) {
            existingRank.items.push({
              item_name,
              item_id,
              quantity,
              packed_quantity,
              delivered_quantity,
              returned_quantity_to_stock,
              returned_quantity: quantity - delivered_quantity,
              returned_quantity_packed: packed_quantity - delivered_quantity,
              returned_quantity_to_stock_status,
              unit_price,
              delivery_status,
              customer_internal_id,
              inv_internal_id,
            });
          } else {
            acc.push({
              rank,
              customer_project_id,
              customer_name,
              inv_internal_id,
              invoice_no,
              items: [
                {
                  item_name,
                  item_id,
                  quantity,
                  packed_quantity,

                  delivered_quantity,
                  returned_quantity_to_stock,
                  returned_quantity_to_stock_status,
                  returned_quantity: quantity - delivered_quantity,
                  returned_quantity_packed:
                    packed_quantity - delivered_quantity,

                  unit_price,
                  delivery_status,
                  customer_internal_id,
                  inv_internal_id,
                },
              ],
            });
          }

          return acc;
        }, []);

        const driverReturn1 = transformedData?.sort(function (a, b) {
          return a.rank - b.rank;
        });
        console.log("driverReturn1", driverReturn1);
        setDriverReturns(driverReturn1);
      } else {
        setType("error");
        setLoadMessage(res?.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const totalWeight = routeOrders?.reduce(
    (total, order) => total + order.orderWeight,
    0,
  );

  const allDelivered = routeOrders?.every(
    (order) => order.delivered > 0 || order.delivered === -1,
  );


  const reminderColumns = [
    {
      title: "Action",
      key: "action",
      // align: "right",
      dataIndex: "",
      render(record, index) {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <Button
              type="primary"
              size="large"
              onClick={() => singleRecord(record)}
            >
              Select
            </Button>
          </div>
        );
      },
    },
    {
      title: "Status",
      render(record) {
        let statusText;
        let backgroundColor;

        switch (record?.delivered) {
          case 1:
            statusText = "Delivered";
            backgroundColor = "#80cb80";
            break;
          case 2:
            statusText = "Postponed";
            backgroundColor = "#f0d787";
            break;
          case -1:
            statusText = "Submitted";
            backgroundColor = "#1890FF";
            break;
          default:
            statusText = "Not Delivered";
            backgroundColor = "#edb1a7";
            break;
        }

        return {
          props: {
            style: {
              background: backgroundColor,
            },
          },
          children: <>{statusText}</>,
        };
      },
    },
    {
      title: "Drop No.",
      dataIndex: "rank",
      key: "rank",
      width: 90,
    },
    {
      title: "Terms",
      key: "terms",
      dataIndex: "terms",
      render: (text, record) => ({
        children:
          record.terms.includes("Cash on Delivery") ||
            record.terms.includes("Cash on Delivery - C") ? (
            <strong>{text}</strong>
          ) : (
            text
          ),
      }),
    },
    {
      title: "Shop Name",
      render: (record) => {
        return (
          <spna>
            <span
              style={{ fontWeight: "bold" }}
            >{`(${record?.customerCode}) `}</span>
            {`${record?.customerName}`}
          </spna>
        );
      },
    },
    // {
    //   title: "Shop Code",
    //   key: "customerCode",
    //   dataIndex: "customerCode",
    // },
    {
      title: "Postcode",
      key: "postCode",
      dataIndex: "postCode",
    },
    {
      title: "Address",
      key: "address",
      dataIndex: "address",
    },
    {
      title: "Order No.",
      render: (record) => {
        return (
          <spna>
            {record?.invoiceNo ? record?.invoiceNo : record?.saleOrderNo}
          </spna>
        );
      },
    },
    {
      title: "Total",
      render: (record) => (
        <>
          <span style={{ fontWeight: 600 }}>£</span>
          {`${record?.orderValue.toFixed(2)}`}
        </>
      ),
    },
    {
      title: "Weight",
      render: (record) => (
        <span>
          {`${record?.orderWeight.toFixed(2)}`}
          <span style={{ fontWeight: 500 }}> Kgs</span>
        </span>
      ),
    },
  ];

  if (!pinValidity) {
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    navigate("/pin");
    localStorage.setItem("routeLocation", false);
    dispatch({ type: "RESET_STATE" });
  }

  if (!securityPinExists) {
    navigate("/pin");
    localStorage.removeItem("DriverName");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.setItem("routeLocation", false);
    dispatch({ type: "RESET_STATE" });
  }

  if (!selectedRoute && pinValidity && securityPinExists)
    navigate("/dashboard");

  const selectedCashUp = () => {
    const updatedOrder = {
      cashAmount: cashAmount,
      cardAmount: cardAmount,
      accountAmount: accountAmount,
    };
    navigate("/cashup", { state: { totalAmounts: updatedOrder } });
  };

  const selectedGoodsReturn = () => {
    navigate("/returns", { state: { goodsReturnDriver: driverReturns } });
  };

  const handleDriveStatus = async (operation) => {
    let rand = Math.random() * 50;
    let str = "";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    try {
      setDriveLeader(true);
      const location = await getCurrentLocation();
      const body = {
        ...location,
        route_status_id: selectedRoute,
        operation,
        route_id: selectedRouteData?.route_id,
        vehicle_id: selectedRouteData?.vehicle_id,
        driver_id: selectedRouteData?.driver_id,
      };
      const res = await Auth.fetch("/driverapp/manual-tachos", {
        method: "POST",
        body: JSON.stringify(body),
      });
      if (res?.ack) {
        const nowISO = moment().toISOString();
        setDriveStatus((prevState) => {
          const updatedStatus = {
            ...prevState,
            isDriving: operation === 1,
            driveStartTime: operation === 1 ? nowISO : null,
            breakStartTime: operation === 0 ? nowISO : null,
          };

          localStorage.setItem("manualTachos", JSON.stringify(updatedStatus));

          return updatedStatus;
        });
      }
    } catch (error) {
      setType("error");
      setLoadMessage(error?.message + str);
    } finally {
      setDriveLeader(false);
    }
  };

  const getStatusLabel = (driveStatus, live = false) => {
    if (!driveStatus) return null;

    const isDriving = driveStatus.isDriving;
    const startTime = isDriving
      ? driveStatus.driveStartTime
      : driveStatus.breakStartTime;

    if (!live) {
      const baseLabel = isDriving ? "Driving" : "On Break";
      return {
        label: startTime ? `${baseLabel} since` : baseLabel,
        time: startTime ? moment(startTime).format("HH:mm") : null,
        type: isDriving ? "drive" : "break",
      };
    }

    return {
      label: isDriving ? "Driving" : "On Break",
      startTime,
      type: isDriving ? "drive" : "break",
    };
  };

  const status = getStatusLabel();

  const returnDefects = () => {
    navigate("/return_defect");
  };

  const useStopwatch = (startTime, isRunning) => {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
      if (!startTime || !isRunning) return;

      const start = new Date(startTime).getTime();

      const interval = setInterval(() => {
        const now = Date.now();
        const diff = Math.floor((now - start) / 1000);
        setSeconds(diff);
      }, 1000);

      return () => clearInterval(interval);
    }, [startTime, isRunning]);

    const format = (total) => {
      const hrs = Math.floor(total / 3600);
      const mins = Math.floor((total % 3600) / 60);
      const secs = total % 60;

      return `${hrs.toString().padStart(2, "0")}:${mins
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    };

    return format(seconds);
  };

  const liveStatus = getStatusLabel(driveStatus, true);
  const formattedTime = useStopwatch(
    liveStatus?.startTime,
    !!liveStatus?.startTime,
  );

  const staticStatus = getStatusLabel(driveStatus, false);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          marginBottom: 10,
          flexWrap: "wrap",
        }}
      >
        {/* LEFT SIDE */}
        {Number(tachoType) === 0 && selectedRouteData?.start_status < 2 && (
          <Space
            split={<Divider type="vertical" style={{ borderColor: "gray" }} />}
            wrap
          >
            {!driveStatus?.isDriving ? (
              <Button
                type="primary"
                size="large"
                onClick={() => handleDriveStatus(1)}
                style={{
                  background: "#52c41a",
                  borderColor: "#52c41a",
                  color: "#fff",
                }}
                loading={driveLeader}
              >
                Start Drive
              </Button>
            ) : (
              <Button
                size="large"
                style={{
                  background: "#faad14",
                  borderColor: "#faad14",
                  color: "#fff",
                }}
                onClick={() => handleDriveStatus(0)}
                loading={driveLeader}
              >
                Break
              </Button>
            )}

            {staticStatus && (driveStatus?.driveStartTime || driveStatus?.breakStartTime) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "8px 14px",
                  borderRadius: 12,
                  background:
                    staticStatus.type === "drive"
                      ? "rgba(82,196,26,0.12)"
                      : "rgba(250,173,20,0.12)",
                  border:
                    staticStatus.type === "drive"
                      ? "1px solid #52c41a"
                      : "1px solid #faad14",
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color:
                      staticStatus.type === "drive" ? "#389e0d" : "#d48806",
                  }}
                >
                  {staticStatus.label}
                </Typography.Text>

                <Typography.Text
                  strong
                  style={{
                    fontSize: 16,
                    letterSpacing: 0.5,
                    color:
                      staticStatus.type === "drive" ? "#135200" : "#874d00",
                  }}
                >
                  {staticStatus.time}
                </Typography.Text>
              </div>
            )}
          </Space>
        )}

        {/* MIDDLE  */}
        <div>
          {Number(tachoType) === 0 && selectedRouteData?.start_status < 2 && (
            <Space
              split={
                <Divider type="vertical" style={{ borderColor: "gray" }} />
              }
              wrap
            >
              {driveStatus?.isDriving && driveStatus?.driveStartTime && (
                <Image
                  preview={false}
                  src={driveIcon}
                  alt="loading"
                  style={{ width: 60, height: 60 }}
                />
              )}

              {!driveStatus?.isDriving && driveStatus?.breakStartTime && (
                <Image
                  preview={false}
                  src={BreakIcon}
                  alt="loading"
                  style={{ width: 60, height: 60 }}
                />
              )}
              {liveStatus?.startTime && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "8px 14px",
                    borderRadius: 12,
                    background:
                      liveStatus.type === "drive"
                        ? "rgba(82,196,26,0.12)"
                        : "rgba(250,173,20,0.12)",
                    border:
                      liveStatus.type === "drive"
                        ? "1px solid #52c41a"
                        : "1px solid #faad14",
                  }}
                >
                  <Typography.Text
                    style={{
                      fontSize: 14,
                      fontWeight: 500,
                      color:
                        liveStatus.type === "drive" ? "#389e0d" : "#d48806",
                    }}
                  >
                    {liveStatus.label}
                  </Typography.Text>
                  •
                  <Typography.Text
                    strong
                    style={{
                      fontSize: 16,
                      letterSpacing: 0.5,
                      color:
                        liveStatus.type === "drive" ? "#135200" : "#874d00",
                    }}
                  >
                    {formattedTime}
                  </Typography.Text>
                </div>
              )}
            </Space>
          )}
        </div>

        {/* RIGHT SIDE */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {Number(tachoType) === 0 && (driveStatus?.driveStartTime || driveStatus?.breakStartTime) && (
            <Button
              type="primary"
              size="large"
              ghost
              onClick={() => getManualTachos(true)}
            >
              Tacho Activity
            </Button>
          )}
          {selectedRouteData?.start_status < 2 ? (
            <Popconfirm
              title="Complete Route"
              description="Are you sure you want to Complete This Route?"
              okText="Yes"
              cancelText="No"
              onConfirm={completeOrder}
              placement="bottomRight"
              okButtonProps={{ style: { height: 40, width: 80, fontSize: 16 } }}
              cancelButtonProps={{
                style: { height: 40, width: 80, fontSize: 16 },
              }}
            >
              <Button type="primary" size="large">
                Complete Route
              </Button>
            </Popconfirm>
          ) : (
            <Popconfirm
              title="Open Route"
              description="Are you sure you want to Open this Route?"
              okText="Yes"
              cancelText="No"
              onConfirm={openOrder}
              placement="bottomRight"
              okButtonProps={{ style: { height: 40, width: 80, fontSize: 16 } }}
              cancelButtonProps={{
                style: { height: 40, width: 80, fontSize: 16 },
              }}
            >
              <Button type="primary" size="large">
                Open Route
              </Button>
            </Popconfirm>
          )}
        </div>
      </div>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card bordered style={{ background: "#f0f0f0" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Statistic
                title="Cash Total"
                value={cashAmount ? cashAmount : 0}
                precision={2}
                form
                valueStyle={{
                  color: "#3f8600",
                }}
                prefix="£"
              />
            </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card bordered style={{ background: "#f0f0f0" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Statistic
                title="Card Total"
                value={cardAmount ? cardAmount : 0}
                precision={2}
                valueStyle={{
                  color: "#3f8600",
                }}
                prefix="£"
              />
            </div>
          </Card>
        </Col>
        {/* <Col span={8}>
          <Card bordered style={{background: '#f0f0f0'}}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Statistic
                title="Bank Total"
                value={accountAmount ? accountAmount : 0}
                precision={2}
                valueStyle={{
                  color: "#3f8600",
                }}
                prefix="£"
              />
            </div>
          </Card>
        </Col> */}
      </Row>

      <div className="page-header">
        <div style={{ display: "flex", alignItems: "center" }}>
          <h2>Shops List</h2>
          <Tooltip title="Refresh Shops List">
            <SyncOutlined
              style={{ fontSize: "25px", color: "blue", marginLeft: "25px" }}
              onClick={() => window.location.reload()}
            />
          </Tooltip>
        </div>
        <div>
          {selectedRouteData && (
            <>
              {selectedRouteData?.start_status <= 1 ? (
                <Button
                  style={{
                    marginRight: "5px",
                  }}
                  size="large"
                  type="primary"
                  onClick={selectedGoodsReturn}
                >
                  Returns
                </Button>
              ) : (
                <>
                  {returnDone ? (
                    <>
                      <Badge
                        count="Submitted"
                        style={{ backgroundColor: "#52c41a" }}
                        offset={[-45, 0]}
                      >
                        <Button
                          icon={<CheckOutlined />}
                          iconPosition="end"
                          style={{
                            marginRight: "5px",
                            color: "green",
                          }}
                          size="large"
                          onClick={selectedGoodsReturn}
                        >
                          Returns
                        </Button>
                      </Badge>
                    </>
                  ) : (
                    <>
                      <Badge count="Not Submitted" offset={[-50, 0]}>
                        <Button
                          style={{
                            marginRight: "5px",
                          }}
                          size="large"
                          type="primary"
                          ghost
                          danger
                          onClick={selectedGoodsReturn}
                          icon={<CloseOutlined />}
                        // danger
                        >
                          Returns
                        </Button>
                      </Badge>
                    </>
                  )}
                  {cashUpDone ? (
                    <>
                      <Badge
                        count="Submitted"
                        style={{ backgroundColor: "#52c41a" }}
                        offset={[-45, 0]}
                      >
                        <Button
                          style={{
                            marginRight: "5px",
                            color: "green",
                          }}
                          size="large"
                          icon={<CheckOutlined />}
                          onClick={selectedCashUp}
                        >
                          Cash Up
                        </Button>
                      </Badge>
                    </>
                  ) : (
                    <>
                      <Badge count="Not Submitted" offset={[-50, 0]}>
                        <Button
                          style={{
                            marginRight: "5px",
                            // color: 'red'
                          }}
                          size="large"
                          type="primary"
                          ghost
                          danger
                          icon={<CloseOutlined />}
                          onClick={selectedCashUp}
                        >
                          Cash Up
                        </Button>
                      </Badge>
                    </>
                  )}
                  {defectDone ? (
                    <>
                      <Badge
                        count="Submitted"
                        style={{ backgroundColor: "#52c41a" }}
                        offset={[-45, 0]}
                      >
                        <Button
                          icon={<CheckOutlined />}
                          iconPosition="end"
                          style={{
                            marginRight: "5px",
                            color: "green",
                          }}
                          size="large"
                          onClick={returnDefects}
                        >
                          Return Defect Sheet
                        </Button>
                      </Badge>
                    </>
                  ) : (
                    <>
                      <Badge count="Not Submitted" offset={[-50, 0]}>
                        <Button
                          style={{
                            marginRight: "5px",
                            // color: 'red'
                          }}
                          size="large"
                          type="primary"
                          ghost
                          danger
                          onClick={returnDefects}
                          icon={<CloseOutlined />}
                        // danger
                        >
                          Return Defect Sheet
                        </Button>
                      </Badge>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>

      <Table
        columns={reminderColumns}
        dataSource={routeOrders}
        pagination={false}
        style={{ overflowX: "auto", marginTop: "10px" }}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "even-row" : "odd-row"
        }
        footer={() => (
          <spna>
            Total Weight: <strong>{totalWeight.toFixed(2)} KGs</strong>
          </spna>
        )}
      />

      <Message type={type} msg={loadMessage} />
      {!!activityLog?.length && (
        <ActivityLog
          open={!!activityLog?.length}
          onClose={() => setActivityLog([])}
          activityLog={activityLog}
        />
      )}
      {Number(tachoType) === 0 && !driveStatus?.isDriving && (
        <ManualTachoModal
          open={showManualTachoModal}
          onOk={() => setShowManualTachoModal(false)}
        />
      )}
    </>
  );
};

export default VehicleRoutes;
